// Share button on the Watch page: the phone's share sheet when available, otherwise copies the episode link.
document.addEventListener('click', async (event) => {
  const share = event.target.closest('[data-share]');
  if (!share) return;
  const url = share.dataset.shareUrl;
  const title = share.dataset.shareTitle;
  if (navigator.share) {
    try { await navigator.share({ title, url }); } catch { /* viewer closed the share sheet */ }
    return;
  }
  try {
    await navigator.clipboard.writeText(url);
    const label = share.querySelector('[data-share-label]');
    if (label) {
      const original = label.textContent;
      label.textContent = share.dataset.copied;
      setTimeout(() => { label.textContent = original; }, 2000);
    }
  } catch { /* clipboard unavailable */ }
});
